const NotificationSetting = ({
    deviceGroup = '',
    optedOut = false,
    typeGroup = '',
} = {}) => ({
    deviceGroup: String(deviceGroup),
    optedOut: Boolean(optedOut),
    typeGroup: String(typeGroup),
});

const NotificationSettings = ({
    notificationPreferences = [],
} = {}) => ({
    settings: notificationPreferences.map(setting => new NotificationSetting(setting)),
});

export default NotificationSettings;
